module.exports = __webpack_public_path__ + "img/clear-hp.20806866.jpeg";